import AppPasswords from './app-passwords-page';

export default function AppPasswordsPage() {
  return <AppPasswords />;
}
